import { createContext } from 'react';

const MasterGainContext = createContext(null);

export default MasterGainContext;
